import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { StaticDictionaryItem } from 'src/app/shared/model/StaticDictionaryItem';
import { StaticDictionaryName } from 'src/app/shared/model/StaticDictionaryName';
import { StaticDictionaryService } from 'src/app/shared/services/static-dictionary.service';
import { ProofDocument } from '../../models/ProofDocument';


@Component({
  selector: 'app-proof-document-form',
  templateUrl: './proof-document-form.component.html',
  styleUrls: ['./proof-document-form.component.scss'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
  deps: [[new SkipSelf(), ControlContainer]]
  }]
})
export class ProofDocumentFormComponent implements OnInit {

@Input() form: UntypedFormGroup;

constructor(private staticDictionaryService: StaticDictionaryService){}

editMode: boolean;
proofDocument: ProofDocument;
proofDocumentTypes$: Observable<StaticDictionaryItem[]>;
proofDocumentKinds$: Observable<StaticDictionaryItem[]>;
proofDocumentConformities$: Observable<StaticDictionaryItem[]>;
proofDocumentRequiredFromOptions$: Observable<StaticDictionaryItem[]>;

ngOnInit(): void {

  this.proofDocumentTypes$ = this.staticDictionaryService.getStaticDictionary(StaticDictionaryName.ProofDocumentType);
  this.proofDocumentKinds$ = this.staticDictionaryService.getStaticDictionary(StaticDictionaryName.ProofDocumentKind);
  this.proofDocumentConformities$ = this.staticDictionaryService.getStaticDictionary(StaticDictionaryName.ProofDocumentConformity);
  this.proofDocumentRequiredFromOptions$ = this.staticDictionaryService.getStaticDictionary(StaticDictionaryName.ProofDocumentRequiredFrom);

  this.proofDocument = this.form.value;
  this.editMode = this.proofDocument.id > 0;
}

}